export default __webpack_public_path__ + "static/media/apple.84431b70.svg";